import { useParams } from 'react-router-dom';
import { config } from "../../data/config";
import { useEffect } from 'react';
import { getCookies } from "cookies-next";
import { useCookies } from 'react-cookie';
import axios from "axios";
import { useState } from "react";
import BreadCrump from "../tools/breadcrump"

import * as React from 'react';
import TissEditor from '../Editor/TissEditor';
import ImageUploader from '../tools/uploaderImage';
import { useTranslation } from 'react-i18next';
import HeaderOfPage from '../tools/headerOfPage';
import Swal from 'sweetalert2';
import changeUrl from "../../hoc/changeur";

type LanguageCode = string;

interface MultilingualField {
    [key: string]: string;
}

export default function EditBlog() {
    const { t } = useTranslation();

    let cookie = getCookies();

    let { Id } = useParams();
    const [cookies, setCookie] = useCookies(['token', 'rule']);
    const [key, setKey] = useState<any>(1);
    const [error, setError] = useState<any>(null);
    const [activeLang, setActiveLang] = useState<LanguageCode>('en');
    const [languages, setLanguages] = useState<Array<{ code: LanguageCode; label: string }>>([]);

    // Helper function to get display name from multilingual or string
    const getDisplayName = (name: any): string => {
        if (!name) return '';
        if (typeof name === 'string') return name;
        if (typeof name === 'object') {
            return name.en || name.fa || name.ku || name.ar || name.tr || '';
        }
        return String(name);
    };

    const [data, setData] = React.useState<any>(null);
    const [saving, setSaving] = useState<boolean>(false);
    
    const save = async () => {
        setSaving(true);
        try {
            var path = `${config.url}/v1/dashboard/bloggroup/${Id}`;

            let res = await axios({
                method: 'put',
                data: data,
                url: path,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            Swal.fire({
                icon: 'success',
                title: t('Success'),
                text: t('Group updated successfully'),
                timer: 1500,
                showConfirmButton: false
            });
        } catch (error: any) {
            Swal.fire({
                icon: 'error',
                title: t('Error'),
                text: error.response?.data?.message || t('Error updating group'),
            });
        } finally {
            setSaving(false);
        }
    }
    // Load languages
    const loadLanguages = async (): Promise<Array<{ code: LanguageCode; label: string }>> => {
        try {
            const res = await axios.get(`${config.url}/v1/language`);
            const languageList = res.data.message || [];
            const mappedLanguages = languageList
                .filter((lang: any) => lang.active)
                .sort((a: any, b: any) => (a.arranged || 0) - (b.arranged || 0))
                .map((lang: any) => ({
                    code: lang.code as LanguageCode,
                    label: lang.label
                }));
            setLanguages(mappedLanguages);
            if (mappedLanguages.length > 0) {
                setActiveLang(mappedLanguages[0].code);
            }
            return mappedLanguages;
        } catch (error) {
            console.error('Error loading languages:', error);
            const fallbackLanguages = [
                { code: 'ku' as LanguageCode, label: 'Kurdish' },
                { code: 'fa' as LanguageCode, label: 'فارسی' },
                { code: 'en' as LanguageCode, label: 'English' },
                { code: 'ar' as LanguageCode, label: 'العربية' },
                { code: 'tr' as LanguageCode, label: 'Türkçe' }
            ];
            setLanguages(fallbackLanguages);
            return fallbackLanguages;
        }
    };

    // Helper function to initialize multilingual field
    const initializeMultilingualField = (field: any, languageCodes: string[]): MultilingualField => {
        if (!field) {
            const obj: MultilingualField = {};
            languageCodes.forEach(code => obj[code] = '');
            return obj;
        }
        if (typeof field === 'string') {
            const obj: MultilingualField = {};
            languageCodes.forEach(code => obj[code] = field);
            return obj;
        }
        if (typeof field === 'object') {
            if (field.nl) {
                field.ku = field.nl;
                delete field.nl;
            }
            const obj: MultilingualField = { ...field };
            languageCodes.forEach(code => {
                if (!obj[code]) obj[code] = '';
            });
            return obj;
        }
        const obj: MultilingualField = {};
        languageCodes.forEach(code => obj[code] = '');
        return obj;
    };

    const load = async (languageCodes: string[] = []) => {
        try {
            var path = `${config.url}/v1/dashboard/bloggroup/${Id}`;

            let res = await axios({
                method: 'get',
                url: path,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            const loadedData = res.data.message;
            const codes = languageCodes.length > 0 
                ? languageCodes
                : ['ku', 'fa', 'en', 'ar', 'tr'];
            
            // Ensure multilingual structure exists
            if (loadedData) {
                loadedData.name = initializeMultilingualField(loadedData.name, codes);
                loadedData.url = initializeMultilingualField(loadedData.url, codes);
                loadedData.title = initializeMultilingualField(loadedData.title, codes);
                loadedData.description = initializeMultilingualField(loadedData.description, codes);
                loadedData.keywords = initializeMultilingualField(loadedData.keywords, codes);
                loadedData.text = initializeMultilingualField(loadedData.text, codes);
            }
            setData(loadedData)
        } catch (error) {

        }
    }
    const inputstyle = "py-3 px-5 block w-full border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:opacity-50 disabled:pointer-events-none bg-white text-gray-900";
    const breadcrump = [
        {
            name: 'Dashboard',
            url: '/dashboard'
        },
        {
            name: 'Blog',
            url: '/dashboard/Blog'
        },
        {
            name: 'Group List',
            url: '/dashboard/Blog/list'
        },
        {
            name: 'Edit Group',
            url: null
        }
    ]
    useEffect(() => {
        const initialize = async () => {
            const loadedLanguages = await loadLanguages();
            const languageCodes = loadedLanguages.length > 0
                ? loadedLanguages.map(l => l.code)
                : ['ku', 'fa', 'en', 'ar', 'tr'];
            await load(languageCodes);
        };
        initialize();
    }, []);

    // Update data when languages change
    useEffect(() => {
        if (languages.length > 0 && data) {
            const languageCodes = languages.map(l => l.code);
            const updatedData = { ...data };
            updatedData.name = initializeMultilingualField(data.name, languageCodes);
            updatedData.url = initializeMultilingualField(data.url, languageCodes);
            updatedData.title = initializeMultilingualField(data.title, languageCodes);
            updatedData.description = initializeMultilingualField(data.description, languageCodes);
            updatedData.keywords = initializeMultilingualField(data.keywords, languageCodes);
            updatedData.text = initializeMultilingualField(data.text, languageCodes);
            setData(updatedData);
        }
    }, [languages]);
    
    if (!data) {
        return (
            <div className="bg-gray-50 min-h-screen p-4 md:p-6">
                <BreadCrump data={breadcrump}></BreadCrump>
                <HeaderOfPage name="Edit Category"></HeaderOfPage>
                <div className="bg-white rounded-xl shadow-sm p-8 mt-6">
                    <div className="flex items-center justify-center">
                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
                    </div>
                    <p className="text-center mt-4 text-gray-600">در حال بارگذاری...</p>
                </div>
            </div>
        );
    }
    
    return (
        <div className="bg-gray-50 min-h-screen p-4 md:p-6">
            <BreadCrump data={breadcrump}></BreadCrump>
            <HeaderOfPage name="Edit Category"></HeaderOfPage>

            {data != null && (
                <div className="mt-6">
                    <div className="bg-white rounded-xl shadow-sm overflow-hidden" dir='rtl'>
                        <div className="p-6 space-y-6">
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                                {/* Thumbnail */}
                                <div className="bg-gray-50 border border-gray-200 rounded-xl p-4 flex flex-col gap-3">
                                    <div>
                                        <h3 className="text-sm font-semibold text-gray-800 mb-1">
                                            تصویر گروه بلاگ
                                        </h3>
                                        <p className="text-xs text-gray-500">
                                            تصویر شاخص برای نمایش این گروه در صفحات مختلف سایت.
                                        </p>
                                    </div>
                                    <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 bg-white">
                                        <ImageUploader id={data.id} component={'BlogGroup'}></ImageUploader>
                                    </div>
                                    <div>
                                        <h3 className="text-sm font-semibold text-gray-800 mb-1">
                                            عکس هدر
                                        </h3>
                                        <p className="text-xs text-gray-500">
                                            تصویر هدر برای نمایش در بالای صفحه گروه.
                                        </p>
                                    </div>
                                    <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 bg-white">
                                        <ImageUploader id={data.id} component={'BlogGroupHeader'}></ImageUploader>
                                    </div>
                                </div>

                                {/* Form */}
                                <div className="md:col-span-2">
                                    <form key={key} className='flex flex-col gap-4'>

                                        {/* Language Selector */}
                                        <div className="mb-4">
                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                زبان
                                            </label>
                                            <div className="flex gap-2">
                                                {languages.map((lang) => (
                                                    <button
                                                        key={lang.code}
                                                        type="button"
                                                        onClick={() => setActiveLang(lang.code)}
                                                        className={`px-4 py-2 text-sm font-medium rounded-lg transition-colors ${
                                                            activeLang === lang.code
                                                                ? 'bg-blue-600 text-white'
                                                                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                                                        }`}
                                                    >
                                                        {lang.label}
                                                    </button>
                                                ))}
                                            </div>
                                        </div>

                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                                    {t('Name')} ({languages.find(l => l.code === activeLang)?.label})
                                                </label>
                                                <input
                                                    value={data.name?.[activeLang] || ''}
                                                    type="text"
                                                    className={`${inputstyle} ${error != null && error['name'] != undefined && 'bg-red-100 border-red-300'} `}
                                                    placeholder="نام گروه بلاگ را وارد کنید"
                                                    onChange={(e) => {
                                                        const nameValue = e.target.value;
                                                        const slugValue = String(changeUrl(nameValue));
                                                        setData({ 
                                                            ...data, 
                                                            name: { 
                                                                ...data.name, 
                                                                [activeLang]: nameValue 
                                                            },
                                                            url: {
                                                                ...data.url,
                                                                [activeLang]: slugValue
                                                            }
                                                        });
                                                    }}
                                                />
                                                {error != null && error['name'] != undefined && <small className="text-red-500 text-xs mt-1 block">{error['name']['message']}</small>}
                                            </div>

                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                                    Code <span className="text-red-500">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    value={data.code || ''}
                                                    className={`${inputstyle} ${error != null && error['code'] != undefined && 'bg-red-100 border-red-300'} `}
                                                    placeholder="مثال: CAT001"
                                                    onChange={(e) => setData({ ...data, code: e.target.value })}
                                                />
                                                {error != null && error['code'] != undefined && <small className="text-red-500 text-xs mt-1 block">{error['code']['message']}</small>}
                                                <p className="mt-1 text-xs text-gray-400">
                                                    کد یکتای گروه (به انگلیسی و بدون فاصله).
                                                </p>
                                            </div>
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                URL ({languages.find(l => l.code === activeLang)?.label})
                                            </label>
                                            <input
                                                type="text"
                                                value={data.url?.[activeLang] || ''}
                                                className={`${inputstyle} ${error != null && error['url'] != undefined && 'bg-red-100 border-red-300'} `}
                                                placeholder="slug"
                                                onChange={(e) => setData({ 
                                                    ...data, 
                                                    url: { 
                                                        ...data.url, 
                                                        [activeLang]: e.target.value 
                                                    } 
                                                })}
                                            />
                                            {error != null && error['url'] != undefined && <small className="text-red-500 text-xs mt-1 block">{error['url']['message']}</small>}
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                {t('Keywords')} ({languages.find(l => l.code === activeLang)?.label})
                                            </label>
                                            <textarea
                                                value={data.keywords?.[activeLang] || ''}
                                                rows={3}
                                                className={inputstyle}
                                                onChange={(e) => setData({ 
                                                    ...data, 
                                                    keywords: { 
                                                        ...data.keywords, 
                                                        [activeLang]: e.target.value 
                                                    } 
                                                })}
                                                placeholder="کلمات کلیدی (با کاما جدا کنید)" />
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                {t('Description')} ({languages.find(l => l.code === activeLang)?.label})
                                            </label>
                                            <textarea
                                                value={data.description?.[activeLang] || ''}
                                                rows={4}
                                                className={inputstyle}
                                                onChange={(e) => setData({ 
                                                    ...data, 
                                                    description: { 
                                                        ...data.description, 
                                                        [activeLang]: e.target.value 
                                                    } 
                                                })}
                                                placeholder="توضیحات گروه" />
                                        </div>

                                        <div className="flex justify-end pt-2">
                                            <button type="button"
                                                onClick={(e) => { save() }}
                                                disabled={saving}
                                                className="inline-flex items-center justify-center gap-x-2 px-6 py-2.5 text-sm font-medium rounded-lg border border-transparent bg-blue-600 text-white hover:bg-blue-700 focus:outline-none focus:bg-blue-700 disabled:opacity-50 disabled:pointer-events-none transition-colors"
                                            >
                                                {saving ? (
                                                    <>
                                                        <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                                                        در حال ذخیره...
                                                    </>
                                                ) : (
                                                    <>
                                                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                                        </svg>
                                                        {t('Update Category')}
                                                    </>
                                                )}
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="mt-6">
                        <div className="bg-white rounded-xl shadow-sm overflow-hidden">
                            <TissEditor component='bloggroup' parent={data.id} />
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}